/**
 * Singleton SSE connection to /api/events.
 * One EventSource is shared across the whole app.
 * Components register handlers with on() and remove them with the returned cleanup fn.
 */

type EventHandler = (data: any) => void

const listeners = new Map<string, Set<EventHandler>>()
let es: EventSource | null = null

const EVENTS = ['analyses-complete'] as const

function connect() {
  if (es) return
  es = new EventSource('/api/events')

  for (const event of EVENTS) {
    es.addEventListener(event, (e: MessageEvent) => {
      try {
        const data = JSON.parse(e.data)
        listeners.get(event)?.forEach((h) => h(data))
      }
      catch { /* malformed event — ignore */ }
    })
  }

  es.onerror = () => {
    es?.close()
    es = null
    // Reconnect after 5s
    setTimeout(connect, 5000)
  }
}

export function useServerEvents() {
  function on(event: string, handler: EventHandler): () => void {
    if (!listeners.has(event)) listeners.set(event, new Set())
    listeners.get(event)!.add(handler)
    return () => listeners.get(event)?.delete(handler)
  }

  return { on, connect }
}
